import { c as _c } from "react/compiler-runtime";
import { FileUploaderDropZone, fileInputAcceptTypes } from '@systemeio/file-manager';
import { FormSelect } from '@systemeio/ui';
import { useCampaignsList } from 'modules/campaigns/hooks/use-campaigns-list';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import ContactSelectTags from 'modules/contacts/contact-page/components/contact-select-tags';
import LastContactsImportsTable from 'modules/contacts/contacts-import/components/last-contacts-imports-table';
import { SelectColumnsForContactsImportModal } from 'modules/contacts/contacts-import/components/select-columns-for-contacts-import-modal';
import { ContactsImportPageLoco } from 'modules/contacts/contacts-import/constants/contacts-import-page-loco';
import { ContactsImportDelimiter, getContactsImportDelimiterSelectOptions } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type';
import { ContactsLastImportsApiInterface } from 'modules/contacts/contacts-import/types/contacts-import-interface';
import { ContactBulkApiInterface } from 'modules/contacts/types/contact-menu-interface';
import { CreateNewTagModal } from 'modules/tags/components/create-new-tag-modal';
import { NextPage } from 'next';
import { useMemo, useRef, useState } from 'react';
import ButtonLikeLink from 'shared/components/button-like-link';
import { InfoBlockOrderedListItem } from 'shared/components/info-block-ordered-list-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { KeyedMutator } from 'swr';
import { CheckCircleIcon, InfoIcon, QuestionMarkIcon } from '@systemeio/ui/icons';
const ContactEdit: NextPage = () => {
  const $ = _c(212);
  const {
    t
  } = useLocoTranslation();
  const lastContactsImportsTableRef = useRef(null);
  const mutateLastContactsImportsTable = useRef(null);
  const [file, setFile] = useState(null);
  const [delimiter, setDelimiter] = useState(ContactsImportDelimiter.comma);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedTags, setSelectedTags] = useState(t0);
  const [selectedCampaignId, setSelectedCampaignId] = useState();
  const {
    campaignsList
  } = useCampaignsList();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[1] !== campaignsList?.items) {
    t1 = campaignsList?.items.map(_temp);
    $[1] = campaignsList?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const campaignsListOptions = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSelectedCampaignId(undefined);
      setSelectedTags([]);
      setDelimiter(ContactsImportDelimiter.comma);
      setFile(null);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearStates = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = mutate => {
      mutateLastContactsImportsTable.current = mutate;
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setMutateLastContactsImports = t3;
  let t4;
  if ($[5] !== t) {
    t4 = getContactsImportDelimiterSelectOptions(t);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const contactsImportDelimiterSelectOptions = t4;
  let t5;
  if ($[7] !== t) {
    t5 = t("dashboard.contact_import.warning_message.text");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span>{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      lastContactsImportsTableRef.current?.scrollIntoView();
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("dashboard.contact_import.warning_message.button");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <ButtonLikeLink className="font-bold" onClick={t7}>{t8}</ButtonLikeLink>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className={"border-danger bg-background-secondary flex flex-col gap-7 rounded-md\n        border-l-[5px] p-6"}>{t6}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <QuestionMarkIcon className="fill-brand-primary mr-2 inline h-[20px] w-[20px]" />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("dashboard.contact_import.instruction.title-2");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <h3 className="mb-4 text-[18px] leading-6">{t11}{t12}</h3>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t("dashboard.contact_import.instruction.first");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t14
    }} />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t) {
    t16 = t("dashboard.contact_import.instruction.second");
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t16
    }} />;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t) {
    t18 = t("dashboard.contact_import.instruction.third");
    $[32] = t;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t18) {
    t19 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t18
    }} />;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t) {
    t20 = t("dashboard.contact_import.instruction.fourth");
    $[36] = t;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t20) {
    t21 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t20
    }} />;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t) {
    t22 = t("dashboard.contact_import.instruction.fifth");
    $[40] = t;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22) {
    t23 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t22
    }} />;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t) {
    t24 = t("dashboard.contact_import.instruction.subparagraph_first");
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t24) {
    t25 = <li className="mb-2">{t24}</li>;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t) {
    t26 = t("dashboard.contact_import.instruction.subparagraph_second");
    $[48] = t;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t26) {
    t27 = <li>{t26}</li>;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t25 || $[53] !== t27) {
    t28 = <ul className="list-disc pl-14">{t25}{t27}</ul>;
    $[52] = t25;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t) {
    t29 = t("dashboard.contact_import.instruction.sixth");
    $[55] = t;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t29) {
    t30 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t29
    }} />;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t15 || $[60] !== t17 || $[61] !== t19 || $[62] !== t21 || $[63] !== t23 || $[64] !== t28 || $[65] !== t30) {
    t31 = <ul className="flex flex-col gap-6">{t15}{t17}{t19}{t21}{t23}{t28}{t30}</ul>;
    $[59] = t15;
    $[60] = t17;
    $[61] = t19;
    $[62] = t21;
    $[63] = t23;
    $[64] = t28;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t) {
    t32 = t("dashboard.contact_import.instruction_popup.title");
    $[67] = t;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t32) {
    t33 = <span className="text-text-primary text-[16px] font-bold leading-6">{t32}</span>;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t) {
    t34 = t("dashboard.contact_import.instruction_popup.first");
    $[71] = t;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t34) {
    t35 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t34
    }} />;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t) {
    t36 = t("dashboard.contact_import.instruction_popup.second");
    $[75] = t;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== t36) {
    t37 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t36
    }} />;
    $[77] = t36;
    $[78] = t37;
  } else {
    t37 = $[78];
  }
  let t38;
  if ($[79] !== t) {
    t38 = t("dashboard.contact_import.instruction_popup.third-2");
    $[79] = t;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== t38) {
    t39 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t38
    }} />;
    $[81] = t38;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  let t40;
  if ($[83] !== t35 || $[84] !== t37 || $[85] !== t39) {
    t40 = <ul className="flex flex-col gap-6">{t35}{t37}{t39}</ul>;
    $[83] = t35;
    $[84] = t37;
    $[85] = t39;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] !== t) {
    t41 = t("dashboard.contact_import.instruction_email.title");
    $[87] = t;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] !== t41) {
    t42 = <span className="text-text-primary text-[16px] font-bold leading-6">{t41}</span>;
    $[89] = t41;
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  let t43;
  if ($[91] !== t) {
    t43 = t("dashboard.contact_import.instruction_email.first");
    $[91] = t;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  let t44;
  if ($[93] !== t43) {
    t44 = <li className="mb-2">{t43}</li>;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] !== t) {
    t45 = t("dashboard.contact_import.instruction_email.second");
    $[95] = t;
    $[96] = t45;
  } else {
    t45 = $[96];
  }
  let t46;
  if ($[97] !== t45) {
    t46 = <li>{t45}</li>;
    $[97] = t45;
    $[98] = t46;
  } else {
    t46 = $[98];
  }
  let t47;
  if ($[99] !== t44 || $[100] !== t46) {
    t47 = <ul className="list-disc pl-3.5">{t44}{t46}</ul>;
    $[99] = t44;
    $[100] = t46;
    $[101] = t47;
  } else {
    t47 = $[101];
  }
  let t48;
  if ($[102] !== t13 || $[103] !== t31 || $[104] !== t33 || $[105] !== t40 || $[106] !== t42 || $[107] !== t47) {
    t48 = <div className={"bg-background-secondary flex h-fit flex-col gap-6\n        rounded-md p-6\n        xl:col-start-2 xl:row-start-1 xl:row-end-7"}>{t13}{t31}{t33}{t40}{t42}{t47}</div>;
    $[102] = t13;
    $[103] = t31;
    $[104] = t33;
    $[105] = t40;
    $[106] = t42;
    $[107] = t47;
    $[108] = t48;
  } else {
    t48 = $[108];
  }
  let t49;
  if ($[109] !== t) {
    t49 = t("dashboard.contact_import.import_file_block.title");
    $[109] = t;
    $[110] = t49;
  } else {
    t49 = $[110];
  }
  let t50;
  if ($[111] !== file) {
    t50 = file && <CheckCircleIcon className="fill-green h-[20px] w-[20px]" />;
    $[111] = file;
    $[112] = t50;
  } else {
    t50 = $[112];
  }
  let t51;
  if ($[113] !== t49 || $[114] !== t50) {
    t51 = <h1 className="mb-6 flex gap-2 self-start text-[17px] lg:self-center">{t49}{t50}</h1>;
    $[113] = t49;
    $[114] = t50;
    $[115] = t51;
  } else {
    t51 = $[115];
  }
  let t52;
  if ($[116] !== t) {
    t52 = t("dashboard.contact_import.form.label.delimiter");
    $[116] = t;
    $[117] = t52;
  } else {
    t52 = $[117];
  }
  let t53;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = data => data && setDelimiter(data);
    $[118] = t53;
  } else {
    t53 = $[118];
  }
  let t54;
  if ($[119] !== contactsImportDelimiterSelectOptions || $[120] !== delimiter || $[121] !== t52) {
    t54 = <div className="flex grow basis-[300px] flex-col gap-9"><FormSelect withoutCloseIcon={true} label={t52} data={contactsImportDelimiterSelectOptions} value={delimiter} onChange={t53} /></div>;
    $[119] = contactsImportDelimiterSelectOptions;
    $[120] = delimiter;
    $[121] = t52;
    $[122] = t54;
  } else {
    t54 = $[122];
  }
  let t55;
  if ($[123] !== file || $[124] !== t) {
    t55 = <>{file ? <p>{file.name}</p> : <p>{t("dashboard.contact_import.form.label.import-file.title")}</p>}</>;
    $[123] = file;
    $[124] = t;
    $[125] = t55;
  } else {
    t55 = $[125];
  }
  let t56;
  if ($[126] !== t) {
    t56 = t("dashboard.contact_import.form.toast.file_upload_complete");
    $[126] = t;
    $[127] = t56;
  } else {
    t56 = $[127];
  }
  let t57;
  if ($[128] !== t55 || $[129] !== t56) {
    t57 = <FileUploaderDropZone acceptTypes={fileInputAcceptTypes.csv} className="grow basis-40 md:shrink-0" dropZoneClassName="h-full" onSelectFile={setFile} label={t55} toastText={t56} />;
    $[128] = t55;
    $[129] = t56;
    $[130] = t57;
  } else {
    t57 = $[130];
  }
  let t58;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <InfoIcon className="fill-brand-primary mr-2 inline" />;
    $[131] = t58;
  } else {
    t58 = $[131];
  }
  let t59;
  if ($[132] !== t) {
    t59 = t("dashboard.contact_import.form.label.import-file.info");
    $[132] = t;
    $[133] = t59;
  } else {
    t59 = $[133];
  }
  let t60;
  if ($[134] !== t59) {
    t60 = <p className="flex items-center">{t58}{t59}</p>;
    $[134] = t59;
    $[135] = t60;
  } else {
    t60 = $[135];
  }
  let t61;
  if ($[136] !== t57 || $[137] !== t60) {
    t61 = <div className="flex flex-col gap-3.5">{t57}{t60}</div>;
    $[136] = t57;
    $[137] = t60;
    $[138] = t61;
  } else {
    t61 = $[138];
  }
  let t62;
  if ($[139] !== t54 || $[140] !== t61) {
    t62 = <div className="flex flex-wrap gap-7">{t54}{t61}</div>;
    $[139] = t54;
    $[140] = t61;
    $[141] = t62;
  } else {
    t62 = $[141];
  }
  let t63;
  if ($[142] !== t51 || $[143] !== t62) {
    t63 = <div className="bg-background-secondary rounded-md p-6">{t51}{t62}</div>;
    $[142] = t51;
    $[143] = t62;
    $[144] = t63;
  } else {
    t63 = $[144];
  }
  let t64;
  if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = () => setSelectedTags([]);
    $[145] = t64;
  } else {
    t64 = $[145];
  }
  let t65;
  if ($[146] !== revalidateModules) {
    t65 = <CreateNewTagModal onCreate={async () => {
      await revalidateModules([RequestModuleEnum.Tags]);
    }} />;
    $[146] = revalidateModules;
    $[147] = t65;
  } else {
    t65 = $[147];
  }
  let t66;
  if ($[148] !== selectedTags || $[149] !== t65) {
    t66 = <ContactSelectTags className="bg-background-secondary rounded-lg p-6 xl:col-start-1" tempTags={selectedTags} setTempTags={setSelectedTags} resetTags={t64} additionalButtonBarComponent={t65} />;
    $[148] = selectedTags;
    $[149] = t65;
    $[150] = t66;
  } else {
    t66 = $[150];
  }
  let t67;
  if ($[151] !== t) {
    t67 = t("dashboard.contact_import.campaign_title");
    $[151] = t;
    $[152] = t67;
  } else {
    t67 = $[152];
  }
  let t68;
  if ($[153] !== t67) {
    t68 = <h1 className="mb-2 self-start text-[17px] lg:self-center">{t67}</h1>;
    $[153] = t67;
    $[154] = t68;
  } else {
    t68 = $[154];
  }
  let t69;
  if ($[155] !== t) {
    t69 = t("dashboard.contact_import.form.label.campaign");
    $[155] = t;
    $[156] = t69;
  } else {
    t69 = $[156];
  }
  let t70;
  if ($[157] !== t69) {
    t70 = <span>{t69}</span>;
    $[157] = t69;
    $[158] = t70;
  } else {
    t70 = $[158];
  }
  let t71;
  if ($[159] !== t68 || $[160] !== t70) {
    t71 = <div className="mb-6">{t68}{t70}</div>;
    $[159] = t68;
    $[160] = t70;
    $[161] = t71;
  } else {
    t71 = $[161];
  }
  const t72 = !campaignsList;
  let t73;
  if ($[162] !== campaignsListOptions || $[163] !== selectedCampaignId || $[164] !== t72) {
    t73 = <div className="flex flex-wrap gap-7"><div className="flex grow basis-[300px] flex-col gap-9"><FormSelect isPreFetching={t72} data={campaignsListOptions} value={selectedCampaignId} onChange={setSelectedCampaignId} /></div></div>;
    $[162] = campaignsListOptions;
    $[163] = selectedCampaignId;
    $[164] = t72;
    $[165] = t73;
  } else {
    t73 = $[165];
  }
  let t74;
  if ($[166] !== t71 || $[167] !== t73) {
    t74 = <div className="flex flex-1 flex-col">{t71}{t73}</div>;
    $[166] = t71;
    $[167] = t73;
    $[168] = t74;
  } else {
    t74 = $[168];
  }
  let t75;
  if ($[169] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <QuestionMarkIcon className="fill-brand-primary inline h-[16px] w-[16px]" />;
    $[169] = t75;
  } else {
    t75 = $[169];
  }
  let t76;
  if ($[170] !== t) {
    t76 = t("dashboard.contact_import.campaign_instruction.title");
    $[170] = t;
    $[171] = t76;
  } else {
    t76 = $[171];
  }
  let t77;
  if ($[172] !== t76) {
    t77 = <div className="mb-10 flex items-center gap-3">{t75}<span className="text-text-primary text-base font-bold">{t76}</span></div>;
    $[172] = t76;
    $[173] = t77;
  } else {
    t77 = $[173];
  }
  let t78;
  if ($[174] !== t) {
    t78 = t("dashboard.contact_import.campaign_instruction.first");
    $[174] = t;
    $[175] = t78;
  } else {
    t78 = $[175];
  }
  let t79;
  if ($[176] !== t78) {
    t79 = <span dangerouslySetInnerHTML={{
      __html: t78
    }} />;
    $[176] = t78;
    $[177] = t79;
  } else {
    t79 = $[177];
  }
  let t80;
  if ($[178] !== t) {
    t80 = t("dashboard.contact_import.campaign_instruction.second");
    $[178] = t;
    $[179] = t80;
  } else {
    t80 = $[179];
  }
  let t81;
  if ($[180] !== t80) {
    t81 = <li className="mb-2">{t80}</li>;
    $[180] = t80;
    $[181] = t81;
  } else {
    t81 = $[181];
  }
  let t82;
  if ($[182] !== t) {
    t82 = t("dashboard.contact_import.campaign_instruction.third");
    $[182] = t;
    $[183] = t82;
  } else {
    t82 = $[183];
  }
  let t83;
  if ($[184] !== t82) {
    t83 = <li>{t82}</li>;
    $[184] = t82;
    $[185] = t83;
  } else {
    t83 = $[185];
  }
  let t84;
  if ($[186] !== t81 || $[187] !== t83) {
    t84 = <ul className="mt-3 list-disc pl-3.5">{t81}{t83}</ul>;
    $[186] = t81;
    $[187] = t83;
    $[188] = t84;
  } else {
    t84 = $[188];
  }
  let t85;
  if ($[189] !== t79 || $[190] !== t84) {
    t85 = <div>{t79}{t84}</div>;
    $[189] = t79;
    $[190] = t84;
    $[191] = t85;
  } else {
    t85 = $[191];
  }
  let t86;
  if ($[192] !== t77 || $[193] !== t85) {
    t86 = <div className="sm:max-w-[340px]"><div className="border-text-secondary/30 rounded-lg border p-6">{t77}{t85}</div></div>;
    $[192] = t77;
    $[193] = t85;
    $[194] = t86;
  } else {
    t86 = $[194];
  }
  let t87;
  if ($[195] !== t74 || $[196] !== t86) {
    t87 = <div className="bg-background-secondary flex flex-wrap gap-8 rounded-md p-6 lg:self-center">{t74}{t86}</div>;
    $[195] = t74;
    $[196] = t86;
    $[197] = t87;
  } else {
    t87 = $[197];
  }
  let t88;
  if ($[198] === Symbol.for("react.memo_cache_sentinel")) {
    t88 = async () => {
      mutateLastContactsImportsTable.current && (await mutateLastContactsImportsTable.current());
    };
    $[198] = t88;
  } else {
    t88 = $[198];
  }
  let t89;
  if ($[199] !== delimiter || $[200] !== file || $[201] !== selectedCampaignId || $[202] !== selectedTags) {
    t89 = <div className="flex justify-center"><SelectColumnsForContactsImportModal file={file} delimiter={delimiter} campaign={selectedCampaignId} tags={selectedTags} onConfirm={t88} clearStates={clearStates} /></div>;
    $[199] = delimiter;
    $[200] = file;
    $[201] = selectedCampaignId;
    $[202] = selectedTags;
    $[203] = t89;
  } else {
    t89 = $[203];
  }
  let t90;
  if ($[204] === Symbol.for("react.memo_cache_sentinel")) {
    t90 = <LastContactsImportsTable ref={lastContactsImportsTableRef} className="rounded-lg lg:col-start-1" setMutateLastContactsImports={setMutateLastContactsImports} />;
    $[204] = t90;
  } else {
    t90 = $[204];
  }
  let t91;
  if ($[205] !== t10 || $[206] !== t48 || $[207] !== t63 || $[208] !== t66 || $[209] !== t87 || $[210] !== t89) {
    t91 = <div className="grid gap-6 lg:gap-11 xl:grid-cols-[1fr_485px]">{t10}{t48}{t63}{t66}{t87}{t89}{t90}</div>;
    $[205] = t10;
    $[206] = t48;
    $[207] = t63;
    $[208] = t66;
    $[209] = t87;
    $[210] = t89;
    $[211] = t91;
  } else {
    t91 = $[211];
  }
  return t91;
};
export const getServerSideProps = getBaseServerSideProps(ContactsImportPageLoco, 'header.top_menu.contacts');
export default ContactEdit;
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}